import React from 'react';
import { Link } from 'react-router';
import  HeaderUserName from './HeaderUserName';
import { Logged, LoggedUserAdmin, UserLogout} from '../login/Login';
import {Col} from 'react-bootstrap';

import styles from './Header.css';

function Menu(prop) {
  if (LoggedUserAdmin()) {
    return (
      <div className="navbar-nav">
        <a className="nav-item nav-link active" href="#user-detail" onClick={prop.navbarHide}>Detail uživatele</a>
        <a className="nav-item nav-link active" href="#" onClick={prop.navbarHide}>Kalendář</a  >
        <a className="nav-item nav-link active" href="#lekce" onClick={prop.navbarHide}>Lekce</a>
        <a className="nav-item nav-link active" href="#statistiky" onClick={prop.navbarHide}>Statistiky</a>
        <a className="nav-item nav-link active" href="#users-list" onClick={prop.navbarHide}>Uživatelé</a>
        <a className="nav-item nav-link active" href="#logout" onClick={prop.Logout}>Odhlásit</a>
      </div>
    )
  }

  return (
    <div className="navbar-nav">
    <a className="nav-item nav-link active" href="#" onClick={prop.navbarHide}>Kalendář</a>
    <a className="nav-item nav-link active" href="#user-detail" onClick={prop.navbarHide}>Detail uživatele</a>
      <a className="nav-item nav-link active" href="#logout" onClick={prop.Logout}>Odhlásit</a>
    </div>
  )
}


export default class Header extends React.Component {

  Logout = () => {
    UserLogout();
    this.props.setUser(0,'');
    browserHistory.push('/')
  }

  navbarHide() {
    $('.navbar-collapse').collapse('hide');
  }

  render() {
    if (!Logged()) {
      return (
        <nav className="navbar navbar-dark bg-dark pt-2 pb-2">
            <Col className="navbar-header" style={{float: 'left'}}>
              <a className="navbar-brand" href="#">Rezervační formulář</a>
            </Col>
            <HeaderUserName setUser={this.props.setUser} />
        </nav>
      );
    }

    return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <a href="#" className="navbar-brand mr-auto">Rezervační formulář</a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarMenu" aria-controls="navbarMenu" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse flex-grow-0" id="navbarMenu">
          <Menu Logout={this.Logout} navbarHide={this.navbarHide} />
        </div>
      </nav>
    )

  }
}



// WEBPACK FOOTER //
// src/components/pages/Header.js